import type { ApprovalChain } from '../approval-chain.model';

export const XN_CAVEAT_REGISTRATION_CHAIN: ApprovalChain = {
  id: 'xn-caveat-registration',
  label: 'Xn Caveat Registration',
  applicationTypes: ['XN_CAVEAT_REGISTRATION'],
  steps: [],
};
